import AxiosInstance from 'config/apiServiceApiGateway'
import { FileUploadPayloadType } from '@astronautsid/wpe-utils'
import { ServiceInternalFileUpload } from 'config/apiServiceFile'

import {
  PrincipalListResponseInterface,
  AddAdsApprovalReqBodyInterface,
  ApprovalListResponseInterface,
  AdsApprovalSubmissionsParamInterface,
  VendorInfoResponseInterface,
  ApprovalSubmissionResponseInterface,
} from 'features/AdsManagement/@types/apiTypes'

interface PrincipalParamInterface {
  seller_name: string
  page_size: number
  page_cursor?: string
}

export const getPrincipalListAPI = (param: PrincipalParamInterface) =>
  AxiosInstance.Get<PrincipalListResponseInterface, true>({
    url: '/ads/internal/v1/creditmanager/credit/balances',
    params: param,
  })

// Hardcoded params is needed for getting this features data only.
export const postApprovalSubmissionsListAPI = (param: AdsApprovalSubmissionsParamInterface) =>
  AxiosInstance.Post<ApprovalListResponseInterface, true>({
    url: '/ads/internal/v1/approvalmanager/submissions',
    data: {
      ...param,
      event_ref_types: [`EVENT_REF_TYPE_INTERNAL_TOPUP`, `EVENT_REF_TYPE_CORRECTION`],
    },
  })

export const postApproveSubmissionsAPI = (submissionId: string) =>
  AxiosInstance.Post<ApprovalSubmissionResponseInterface, true>({
    url: '/ads/internal/v1/approvalmanager/submissions/approve',
    data: {
      submission_id: submissionId,
    },
  })

export const postRejectSubmissionsAPI = (submissionId: string, reason: string) =>
  AxiosInstance.Post<ApprovalSubmissionResponseInterface, true>({
    url: '/ads/internal/v1/approvalmanager/submissions/reject',
    data: {
      submission_id: submissionId,
      rejection_note: reason,
    },
  })

export const postUploadAdsAgreementFile = (payload: FileUploadPayloadType[]) =>
  ServiceInternalFileUpload(payload)

export const postAdsSubmissionsAPI = (body: AddAdsApprovalReqBodyInterface) =>
  AxiosInstance.Post<ApprovalListResponseInterface, true>({
    url: '/ads/internal/v1/approvalmanager/submissions/create',
    data: body,
  })

export const getVendorInfoAPI = (sellerId: string) =>
  AxiosInstance.Get<VendorInfoResponseInterface, true>({
    url: `/commercial/internal/v1/vendors/${sellerId}`,
  })
